// Data.tsx
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/header";
import IconFinance from "../../componentsStyled/icon/IconFinance";
import ValeCompras from "../../components/vale-compras";
import ValeEstorno from "../../components/ValeEstorno";
import IconBack from "../../componentsStyled/icon/Iconback";
import { Box, Button } from "@mui/material";
import MenuLateral from "../../components/MenuLateral";
import HeaderMobile from "../../components/headerMobile";
import ChatFlutuant from "../../components/ChatFlutuant";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MiniStepper from "../../components/miniStepper";

interface DataProps {
  onDataUpdate?: (data: any) => void;
}

const Data: React.FC<DataProps> = ({ onDataUpdate }) => {
  const location = useLocation();
  const [dadosSelecionadosAtualizados, setDadosSelecionadosAtualizados] = useState(location.state || []);
  const [isInformationConfirmed, setIsInformationConfirmed] = useState<boolean>(false);
  const navigate = useNavigate();
  const [tipoPix, setTipoPix] = useState<string | null>(null);
  const [chavePix, setChavePix] = useState("");
  const [updatedData, setUpdatedData] = useState<any>({});
  const [bank, setBank] = useState<string>("");
  const [cpfcnpj, setCpfcnpj] = useState<string>("");
  const [accont, setAccont] = useState<string>("");
  const [agency, setAgency] = useState<string>("");
  const [typebank, setTypeBank] = useState<string>("");
  const [areAllCheckboxesChecked, setAreAllCheckboxesChecked] = useState<boolean>(false);
  const [checkboxStates, setCheckboxStates] = useState<{ [key: string]: boolean }>({});

  const updateTipoPix = (tipoPixValue: string | null) => {
    setTipoPix(tipoPixValue);
  };

  const updateChavePix = (chavePixValue: string) => {
    setChavePix(chavePixValue);
  };

  const updateBank = (bankValue: string) => {
    setBank(bankValue);
  };

  const updateCpfcnpj = (cpfcnpjValue: string) => {
    setCpfcnpj(cpfcnpjValue);
  };

  const updateAccont = (accontValue: string) => {
    setAccont(accontValue);
  };

  const updateAgency = (agencyValue: string) => {
    setAgency(agencyValue);
  };

  const updateTypeBank = (typebankValue: string) => {
    setTypeBank(typebankValue);
  };

  const updateCheckboxState = (key: string, value: boolean) => {
    setCheckboxStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleCheckboxChange = (tipoReembolso: string) => (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    //console.log(`Checkbox clicked for tipoReembolso: ${tipoReembolso}, Checked: ${event.target.checked}`);

    updateCheckboxState(tipoReembolso, event.target.checked);

    if (Array.isArray(dadosSelecionadosAtualizados)) {
      const updatedData = dadosSelecionadosAtualizados.map((produto: any, idx: number) => {
        if (produto.selectedProduct?.tipoReembolso === tipoReembolso) {
          return {
            ...produto,
            checkbox: event.target.checked,
          };
        }
        return produto;
      });

      setDadosSelecionadosAtualizados(updatedData);
    }
  };

  useEffect(() => {
    //console.log('Checkbox States:', checkboxStates);

    const allCheckboxesChecked =
      Array.isArray(dadosSelecionadosAtualizados) &&
      dadosSelecionadosAtualizados.every((produto: any, index: number) => checkboxStates[`${produto.selectedProduct?.tipoReembolso}`]);

    setAreAllCheckboxesChecked(allCheckboxesChecked);
  }, [checkboxStates, dadosSelecionadosAtualizados]);

  const renderReembolsoComponent = () => {
    const tiposReembolso = dadosSelecionadosAtualizados.map((produto: any) => produto.selectedProduct?.tipoReembolso);

    if (tiposReembolso.every((tipo, index, array) => tipo === array[0])) {
      const firstProduct = dadosSelecionadosAtualizados[0];
      const { id: productId, variant_value: variantValue } = firstProduct;
      return renderReembolsoByType(tiposReembolso[0], productId, variantValue);
    }
    return null;
  };
  const renderReembolsoByType = (tipoReembolso: string, productId: number, variantValue: string, index?: number) => {
    const reembolsoComponents = {
      Cupom: <ValeCompras onCheckboxChange={handleCheckboxChange(tipoReembolso)(index)} />,
      Estorno: (
        <ValeEstorno
          onCheckboxChange={handleCheckboxChange(tipoReembolso)(index)}
          produtos={dadosSelecionadosAtualizados}
          onConfirm={() => setIsInformationConfirmed(true)}
          tipoPix={tipoPix}
          chavePix={chavePix}
          bank={bank}
          cpfcnpj={cpfcnpj}
          accont={accont}
          agency={agency}
          updateTipoPix={updateTipoPix}
          updateChavePix={updateChavePix}
          updateBank={updateBank}
          updateCpfcnpj={updateCpfcnpj}
          updateAccont={updateAccont}
          updateAgency={updateAgency}
          updateTypeBank={updateTypeBank}
        />
      ),
    };

    return reembolsoComponents[tipoReembolso] || null;
  };

  const isSameReembolsoType =
    Array.isArray(dadosSelecionadosAtualizados) &&
    dadosSelecionadosAtualizados.length > 0 &&
    dadosSelecionadosAtualizados.every(
      (produto: any, index: number, array: any[]) => produto.selectedProduct?.tipoReembolso === array[0].selectedProduct?.tipoReembolso
    );

  const renderDifferentReembolsoComponent = (tipoReembolso: string, productId: number, variantValue: string) => {
    return renderReembolsoByType(tipoReembolso, productId, variantValue);
  };

  const handleConfirmar = () => {
    let areAllCheckboxesChecked = Object.values(checkboxStates).every((isChecked) => isChecked);

    dadosSelecionadosAtualizados.forEach((produto: any, index: number) => {
      if (produto.selectedProduct?.tipoReembolso.toLowerCase() === "estorno" && !areAllCheckboxesChecked) {
        areAllCheckboxesChecked = false;
      }
    });
    if (areAllCheckboxesChecked) {
      const dadosFinais = dadosSelecionadosAtualizados.map((produto: any, index: number) => {
        if (produto.selectedProduct?.tipoReembolso?.toLowerCase() === "estorno") {
          return {
            ...produto,
            BankReembolso: {
              pixData: {
                tipoPix: tipoPix,
                chavePix: chavePix,
              },
              bankData: {
                bank: bank,
                cpfcnpj: cpfcnpj,
                agency: agency,
                accont: accont,
                typebank: typebank,
              },
            },
          };
        }
        return produto;
      });

      setUpdatedData([...dadosFinais]);
      if (onDataUpdate) {
        onDataUpdate(dadosSelecionadosAtualizados);
      }

      navigate("/shipping", { state: dadosFinais || dadosSelecionadosAtualizados });
    }
  };

  const handleBack = () => {
    navigate("/order");
  };

  const settings = {
    dots: true,
    arrow: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // adaptiveHeight: true,
  };

  return (
    <>
      {/* desktop */}
      <Box display={{ xs: "none", md: "initial" }}>
        <Header />
        <Box display={"flex"} width={"100%"} justifyContent={"center"} mt={5}>
          <MenuLateral currentPage="request" />
          <Box width={"100%"}>
            <Button onClick={handleBack} sx={{ color: "#000" }}>
              <IconBack width={20} />
              Informações do reembolso
            </Button>
            <Box display={"flex"} width={"90%"} justifyContent={"right"}>
              <MiniStepper step={2} />
            </Box>
            <Slider {...settings}>
              {isSameReembolsoType ? (
                <Box>
                  <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                    <IconFinance width={64} />
                  </Box>
                  {renderReembolsoComponent()}
                </Box>
              ) : (
                dadosSelecionadosAtualizados?.length > 0 &&
                dadosSelecionadosAtualizados?.map((produto: any, index: number) => (
                  <Box key={`${produto.id}-${index}`}>
                    <Box display={"flex"} gap={1} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
                      <img src={produto.img} style={{ width: 150, borderRadius: 10 }} alt={`Product ${index}`} />
                      <p style={{ color: "#000", fontSize: 20 }}>{produto.name}</p>
                      <p style={{ color: "#000" }}>Variação: {produto.variant_value}</p>
                    </Box>
                    {renderDifferentReembolsoComponent(produto.selectedProduct?.tipoReembolso, produto.id, produto.variant_value)}
                  </Box>
                ))
              )}
            </Slider>

            <Button
              variant="contained"
              onClick={handleConfirmar}
              disabled={!areAllCheckboxesChecked}
              sx={{
                backgroundColor: "#221F20",
                color: "#fff",
                borderRadius: 100,
                width: 450,
                marginTop: 4,
                display: "flex",
                marginLeft: "auto",
                marginRight: "auto",
                "&:hover": {
                  backgroundColor: "#727272",
                  color: "#ffffff",
                },
              }}>
              Confirmar
            </Button>
          </Box>
        </Box>
      </Box>
      {/* desktop */}

      {/* Mobile */}
      <Box display={{ xs: "initial", md: "none" }}>
        <HeaderMobile currentPage="request" />
        <Box>
          <Box display={"flex"} width={"100%"} justifyContent={"center"} mb={2}>
            <MiniStepper step={2} />
          </Box>
          <Button onClick={handleBack} sx={{ color: "#000" }}>
            <IconBack width={20} />
            Informações do reembolso
          </Button>
          <Slider {...settings}>
            {isSameReembolsoType ? (
              <Box>
                <Box display={"flex"} justifyContent={"center"}>
                  <IconFinance width={64} />
                </Box>
                {renderReembolsoComponent()}
              </Box>
            ) : (
              dadosSelecionadosAtualizados?.length > 0 &&
              dadosSelecionadosAtualizados?.map((produto: any, index: number) => (
                <Box key={`${produto.id}-${index}`}>
                  <Box display={"flex"} gap={1} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
                    <img src={produto.img} style={{ width: 150, borderRadius: 10 }} alt={`Product ${index}`} />
                    <p style={{ color: "#000", fontSize: 20, textAlign: "center" }}>{produto.name}</p>
                    <p style={{ color: "#000" }}>Variação: {produto.variant_value}</p>
                  </Box>
                  {renderDifferentReembolsoComponent(produto.selectedProduct?.tipoReembolso, produto.id, produto.variant_value)}
                </Box>
              ))
            )}
          </Slider>

          <Button
            variant="contained"
            onClick={handleConfirmar}
            disabled={!areAllCheckboxesChecked}
            sx={{
              backgroundColor: "#221F20",
              color: "#fff",
              borderRadius: 100,
              width: 200,
              marginTop: 8,
              display: "flex",
              marginLeft: "auto",
              marginRight: "auto",
              "&:hover": {
                backgroundColor: "#727272",
                color: "#ffffff",
              },
            }}>
            Confirmar
          </Button>
        </Box>
      </Box>
      {/* Mobile */}
      <ChatFlutuant />
    </>
  );
};

export default Data;
